import { useQuery } from '@tanstack/react-query';

import { getInvoiceDetails } from '../api';
import { INVOICES_QUERY_KEY } from './use-inovices';

const INVOICE_DETAILS_STALE_TIME = 5 * 60 * 1000;

export const getInvoiceDetailsQueryKey = (invoiceId: number) =>
  [INVOICES_QUERY_KEY, 'details', invoiceId] as const;

/** Fetches invoice details only after a valid positive numeric route ID is available. */
export const useInvoiceDetails = (invoiceId: number | undefined) =>
  useQuery({
    queryKey: getInvoiceDetailsQueryKey(invoiceId ?? 0),
    queryFn: () => getInvoiceDetails(invoiceId as number),
    enabled: typeof invoiceId === 'number' && Number.isInteger(invoiceId) && invoiceId > 0,
    staleTime: INVOICE_DETAILS_STALE_TIME,
  });
